@if (selected?.image) {
  <div class="super-banner">
    <button mat-icon-button
      class="super-banner-toggle"
      [ngClass]="{'hidden-position': hidden}"
      (click)="toggleBanner()">
      <mat-icon>{{ hidden ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    @if (selected) {
      <div class="banner-wrapper"
        [@slideUpDown]="hidden ? 'hidden' : 'visible'">
        <a [href]="selected?.link" target="_blank" (click)="mtmEvent(selected?.title)">
          <img [src]="CDN +'/marketing-management/'+ selected?.image"
            [alt]="selected?.title"
            class="super-banner-image"/>
          </a>
        </div>
      }
    </div>
  }